<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="12">
        <b-card>
          <div slot="header">
            <strong><i class="fa fa-align-justify"/> Inscription CeV</strong>
          </div>
          <b-row>
            <b-col md="12" v-if="showResult == false">
              <b-form>
                <h6 v-if="etablissement" style="color:#850404d4;">La structure est connue du référentiel utilisé, vous pouvez compléter les produits si besoin :</h6>
                <label v-else style="color:#850404d4;">La structure n'est pas connue du référentiel utilisé, veuillez saisir les informations suivantes :</label>
                <b-card no-body>
                  <div class="card-smallHeader card-header-action mb-2">
                    <span style="color:#d9418b" class="mr-2"> <b>Informations sur la structure</b></span>
                  </div>
                  <b-card-body>
                    <b-row class="mb-1">
                      <b-col sm="2">
                        <label for="siren"><strong>SIREN : </strong></label>
                      </b-col>
                      <b-col sm="3">
                        <label>{{ etablissement ? etablissement.siren : siren }}</label><br>
                      </b-col>
                      <b-col sm="2">
                        <label for="nic"><strong>NIC : </strong></label>
                      </b-col>
                      <b-col sm="3">
                        <label>{{ etablissement ? etablissement.siret.substring(9,14) : nic  }}</label><br>
                      </b-col>
                    </b-row>
                    <b-row class="mb-1">
                      <b-col sm="2">
                        <label for="raison_sociale"><strong>Raison sociale Souscripteur : </strong></label>
                      </b-col>
                      <b-col sm="3">
                        <label v-if="entreprise">{{ entreprise.raison_sociale }}</label>
                        <b-form-input
                          v-if="isEmpty(entreprise)"
                          id="raison_sociale"
                          type="text"
                          v-model="raison_sociale"
                        />
                      </b-col>



                      <b-col sm="2">
                        <label for="nic"><strong>Libellé du Site assuré : </strong></label>
                      </b-col>
                      <b-col sm="3">
                        <label v-if="etablissement">{{ etablissement.libelle }}</label>
                        <b-form-input
                          v-if="isEmpty(etablissement)"
                          id="libelle"
                          type="text"
                          v-model="libelle"
                        />
                      </b-col>
                    </b-row>
                    <b-row class="mb-1">
                      <b-col sm="2">
                        <label for="produit_dispo"><strong>Famille du Produit : </strong></label>
                      </b-col>
                      <b-col sm="3">
                        <b-form-checkbox-group
                          v-if="!isEmpty(produitsOptions)"
                          id="checkbox-group-2"
                          v-model="produitsId"
                          :options="produitsOptions"
                          name="produitsOptions"
                          stacked
                        >
                        </b-form-checkbox-group><br>
                        <span v-if="canAccessProduitDedie()"><label>----- Contrats dédiés -----</label></span>
                        <b-form-checkbox-group
                          v-if="!isEmpty(produitsDediesOptions) && canAccessProduitDedie()"
                          id="checkbox-group-3"
                          v-model="produitsId"
                          :options="produitsDediesOptions"
                          name="produitsDediesOptions"
                          stacked
                        >
                        </b-form-checkbox-group>
                      </b-col>
                    </b-row>
                  </b-card-body>
                  <div class="mt-1" slot="footer">
                    <b-button type="button" @click.prevent="createFictif" size="md" class="pull-right" variant="primary">
                      <i class="fa fa-random"/> Générer les codes d'accès
                    </b-button>
                    <b-button type="button" @click.prevent="cancel" size="md" class="pull-right mr-3" variant="secondary">
                      <i class="fa fa-close"/> Annuler
                    </b-button>
                  </div>
                </b-card>
              </b-form>
            </b-col>
            <b-col md="12" v-if="showResult == true">
              <b-form>
                <label>Veuillez trouver ci-dessous les informations à communiquer au client pour lui permettre de s'inscrire ou d'ajouter la structure :</label>
                <b-card no-body>
                  <div class="card-smallHeader card-header-action mb-2">
                    <span style="color:#d9418b" class="mr-2"> <b>Informations sur la structure</b></span>
                  </div>
                  <b-card-body>
                    <b-row class="mb-1">
                      <b-col sm="2">
                        <label for="numeroAvis"><strong>N° d'Avis d'Appel : </strong></label>
                      </b-col>
                      <b-col sm="3">
                        <label><strong>{{ numeroAvis }}</strong></label><br>
                      </b-col>
                    </b-row>
                    <b-row class="mb-1">
                      <b-col sm="2">
                        <label for="nic"><strong>N° Code de dématérialisation : </strong></label>
                      </b-col>
                      <b-col sm="3">
                        <label><strong>{{ codeDemat }}</strong></label><br>
                      </b-col>
                    </b-row>
                    <b-row class="mb-1">
                      <b-col sm="6">
                        <label>Veuillez noter précieusement ces informations avant de les communiquer au client.</label>
                      </b-col>
                    </b-row>
                  </b-card-body>
                  <div class="mt-1" slot="footer">
                    <b-button type="button" @click.prevent="cancel" size="md" class="pull-right" variant="secondary">
                      <i class="fa fa-search"/> Retour
                    </b-button>
                  </div>
                </b-card>
              </b-form>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import {getAccessToken, getBaseUrl, getIdToken, getProvider} from '../../utils/auth';
  import { espaceEmployeurRules as rules, hasRule } from "@/utils/rulesHelper";
  import { isEmpty } from "@/utils/fileHelper";

  export default {
  data() {
    return {
      etablissement: '',
      entreprise: '',
      siren: '',
      nic: '',
      libelle: '',
      raison_sociale: '',
      isEmpty,
      produitSiret: [],
      produitsOptions: [],
      produitsDediesOptions: [],
      produitsId: [],
      showResult: false,
      numeroAvis: '',
      codeDemat: '',
      checkDisabled: false
    }
  },
  mounted() {
  },
  created() {
    this.$axios.defaults.baseURL = getBaseUrl();
    this.$axios.defaults.headers.common['Authorization'] = getIdToken() + ' ' + getAccessToken()
    this.$axios.defaults.headers.common['Accept'] = 'application/json';
    this.$axios.defaults.headers.common['Provider'] = getProvider();
    this.etablissement = this.$route.query.etablissement
    this.siren = this.$route.query.siren
    this.nic = this.$route.query.nic
    this.entreprise = this.$route.query.entreprise
    if (!isEmpty(this.etablissement)) {
      this.getFamilleProduits()
    }
    this.getProduitsDispo()
  },
  methods: {
    getFamilleProduits() {
      return new Promise((resolve, reject) => {
        this.$store.commit('IS_LOADING', true)
        let self = this
        let siret = this.etablissement ? this.etablissement.siret : this.siren + this.nic
        this.$axios
          .get("/espaceEmployeur/inscription-cev/search/famille/" + siret)
          .then(response => {
            this.$store.commit("IS_LOADING", false)
            this.produitSiret = response.data.famille
            resolve()

          })
          .catch(function (error) {
            self.$store.commit("IS_LOADING", false);
            self.$swal({
              position: "top",
              type: "error",
              title: "Attention !!",
              text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",
              showConfirmButton: false,
              timer: 5000
            });
          });
      })
    },
    cancel() {
      this.$router.push({ path: '/espace-employeur/inscription-cev' })
    },
    getProduitsDispo() {
      this.$store.commit('IS_LOADING', true)
      let self = this
      this.$axios
        .get("/espaceEmployeur/inscription-cev/search/produit-dispo")
        .then(async response => {
          this.$store.commit("IS_LOADING", false)
          await this.getFamilleProduits()
          if (!isEmpty(response.data.famille)) {
            let contratsDedies = response.data.famille.filter((famille) => famille.ordre >= 110)
            let familleProduits = response.data.famille.filter((famille) => famille.ordre < 110)

            for (let famille of familleProduits) {
              this.produitsOptions.push({ text: famille.libelle_famille, value: famille.id_famille_cev })

              if (!isEmpty(this.produitSiret)) {
                if (this.produitSiret.includes(famille.id_famille_cev)) {
                  this.produitsId.push(famille.id_famille_cev)
                  this.checkDisabled = true
                }
              }
            }
            for (let famille of contratsDedies) {
              this.produitsDediesOptions.push({ text: famille.libelle_famille, value: famille.id_famille_cev })

              if (!isEmpty(this.produitSiret)) {
                if (this.produitSiret.includes(famille.id_famille_cev)) {
                  this.checkDisabled = true
                  this.produitsId.push(famille.id_famille_cev)
                }
              }
            }
          }
        })
        .catch(function (error) {
          self.$store.commit("IS_LOADING", false);
          self.$swal({
            position: "top",
            type: "error",
            title: "Attention !!",
            text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",
            showConfirmButton: false,
            timer: 5000
          });
        });
    },
    canAccessProduitDedie() {
        return hasRule(rules.CAN_ACCESS_PRODUIT_DEDIE_INSCRIPTION);
    },
    createFictif() {
      this.$store.commit('IS_LOADING', true)
      let self = this
      let dataPost = {}
      dataPost.siren = this.etablissement ? this.etablissement.siren : this.siren
      dataPost.nic = this.etablissement ? this.etablissement.siret.substring(9, 14) : this.nic
      dataPost.libelle = this.etablissement ? this.etablissement.libelle : this.libelle
      dataPost.raisonSociale = this.entreprise ? this.entreprise.raison_sociale : this.raison_sociale
      dataPost.produitsId = this.produitsId
      this.$axios
        .post("/espaceEmployeur/inscription-cev/store", dataPost)
        .then(response => {
          this.$store.commit("IS_LOADING", false)
          this.showResult = true
          this.numeroAvis = response.data.data.numero_avis_fictif
          this.codeDemat = response.data.data.code_demat_fictif
        })
        .catch(function (error) {
          self.$store.commit("IS_LOADING", false);
          self.$swal({
            position: "top",
            type: "error",
            title: "Attention !!",
            text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",
            showConfirmButton: false,
            timer: 5000
          });
        });
    }
  }
}
</script>

<style>

</style>
